import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_STA015_Request,
  IAPI_STA015_Response,
} from "../../../type/apiType";

// 加入登録手続き更新
const httpAPI_STA015 = async (
  param: IAPI_STA015_Request
): Promise<IAPI_STA015_Response> => {
  let res = await http.post(ApiUrl.API_STA015, {
    ...param,
  });

  return res.data;
};

export { httpAPI_STA015 };
